import { Loop } from "@mui/icons-material";
import { Container, IconButton, Typography } from "@mui/material";
import { FeedbackThumbs, Message } from "../../interfaces/chabot";
import { InternalError } from "../Errors/InternalError";
import Loading from "../Loading";
import ChatInput from "./ChatInput";
import MessageList from "./MessageList";
import {
  useChatPdf,
  useResetChatPdf,
  useSendFeedbackPdf,
  useSendMessagePdf,
} from "./SiriusQueries";

function ChatPdf({
  assetId,
  processing,
}: {
  assetId: string;
  processing: any;
}) {
  const { data: chat, isError, isLoading } = useChatPdf(assetId);
  const { mutate: sendMessage, isPending: awaitingResponse } =
    useSendMessagePdf(assetId, chat?.id);
  const { mutate: feedbackMutate } = useSendFeedbackPdf(assetId, chat?.id);
  const { mutate: resetChat } = useResetChatPdf(assetId);

  const sendFeedback = (message: Message, feedback: FeedbackThumbs) => {
    feedbackMutate({
      messageId: message.id,
      feedback: feedback === message.feedback ? null : feedback,
    });
  };

  if (isError) {
    return <InternalError />;
  } else if (isLoading) {
    return <Loading />;
  } else if (!!chat) {
    return (
      <Container
        maxWidth={false}
        className="flex grow w-full flex-col overflow-hidden items-center p-0"
      >
        <div className="flex w-full justify-between items-center">
          <Typography className="font-bold">
            Comment puis-je vous aider ?
          </Typography>
          <IconButton onClick={() => resetChat()} className="font-black">
            <Loop />
          </IconButton>
        </div>
        <MessageList
          messages={chat.messages}
          handleFeedback={sendFeedback}
          loading={awaitingResponse}
        />
        <div className="flex flex-col w-full px-4 lg:max-w-3xl xl:max-w-4xl lg:px-0">
          <ChatInput
            chatId={chat.id}
            loading={awaitingResponse}
            sendMessage={(content: string) =>
              sendMessage({ content: content, processing: processing })
            }
          />
          <Typography className="w-full p-2 text-center text-xs">
            Notre chatbot peut faire des erreurs. Pensez à vérifier les
            informations importantes
          </Typography>
        </div>
      </Container>
    );
  } else {
    return <InternalError />;
  }
}

export default ChatPdf;
